import { makeVar } from "@apollo/client";
import { UserRole } from "__generated__/graphql";
import { PermissionValue } from "redux/slices/role";
import { CognitoUser } from "amazon-cognito-identity-js";

export type AttributesValue = {
  name?: string;
  phoneNumber?: string;
  signature?: any;
  email?: string;
};

export type SettingUserValue = {
  yellowLevel?: any;
  chalkyLevel?: any;
  undermilledLevel?: any;
  damagedLevel?: any;
  headLevel?: any;
  isAutoYellow: boolean;
};

export type InferenceSettingValue = {
  riceGroupID?: string;
  riceGroupName?: string;
  settingLevel?: {
    value: string | number;
    isAuto: boolean;
    isAdvance: boolean;
    inferenceSettingID: string;
  }[];
};

export type PackageUserValue = {
  status: "active" | "inactive";
  type?: "upfront" | "subscription" | "trial";
  label: "normal" | "pro" | "enterprise" | "trial";
  name?: string;
  maxUsage?: number;
  currentUsage?: number;
  startDate?: string;
  expiredDate?: string;
  billingCycleDate?: string;
  isLimitReached?: boolean;
  isBeforeExpired?: boolean;
};

export type UserType = {
  username?: string;
  role?: UserRole;
  country?: "";
  isFeedbackShowUp?: any;
  isShowInfoVersion?: any;
  isBeforeMaExpired?: any;
  isMaExpired?: any;
  millID?: string;
  millName?: string;
  flags?: {
    "new-feature-full"?: boolean;
    "new-feature-inspect"?: boolean;
  };
  expriedDate?: string;
  package?: PackageUserValue;
  permission: PermissionValue;
  attributes?: AttributesValue;
  inferenceSetting: InferenceSettingValue[]
} & SettingUserValue;

export const user = makeVar<UserType>(null);
export const cognitoUser = makeVar<any>(null);
export const isAuth = makeVar<boolean>(false);
export const maintenanceDetail = makeVar(null);
export const isMaintenance = makeVar(false);
